import React, { FC } from 'react';
import AMAZON from '../../../app/assets/images/companyLogos/amazon.svg';
import DRIBBLE from '../../../app/assets/images/companyLogos/dribble.svg';
import HUBSPOT from '../../../app/assets/images/companyLogos/hubspot.svg';
import NOTION from '../../../app/assets/images/companyLogos/notion.svg';
import ZOOM from '../../../app/assets/images/companyLogos/zoom.svg';
import NETFLIX from '../../../app/assets/images/companyLogos/netflix.svg';

interface CompanyLogoImageProps {
    borderColor?: string;
    bgColor?: string;
}

const CompanyLogoImage: FC<CompanyLogoImageProps> = ({ borderColor = 'border-[#2a2a2a]', bgColor = 'bg-blackDark' }) => {
    return (
        <div className={`gap-4 sm:gap-6 md:gap-8 w-full flex flex-wrap justify-center md:justify-between items-center text-base font-medium font-sans leading-6 border-2 md:border-4 ${borderColor} p-4 sm:p-6 md:p-10 ${bgColor} rounded-md sm:rounded-lg`}>
            <div className='w-1/3 sm:w-1/4 md:w-auto flex justify-center p-2 md:p-0'>
                <img src={AMAZON} alt="Amazon logo" className='w-[60px] sm:w-[70px] md:w-[80px]' />
            </div>
            <div className='w-1/3 sm:w-1/4 md:w-auto flex justify-center p-2 md:p-0'>
                <img src={DRIBBLE} alt="Dribbble logo" className='w-[60px] sm:w-[70px] md:w-[80px]' />
            </div>
            <div className='w-1/3 sm:w-1/4 md:w-auto flex justify-center p-2 md:p-0'>
                <img src={HUBSPOT} alt="HubSpot logo" className='w-[60px] sm:w-[70px] md:w-[80px]' />
            </div>
            <div className='w-1/3 sm:w-1/4 md:w-auto flex justify-center p-2 md:p-0'>
                <img src={NOTION} alt="Notion logo" className='w-[60px] sm:w-[70px] md:w-[80px]' />
            </div>
            <div className='w-1/3 sm:w-1/4 md:w-auto flex justify-center p-2 md:p-0'>
                <img src={ZOOM} alt="Zoom logo" className='w-[60px] sm:w-[70px] md:w-[80px]' />
            </div>
            <div className='w-1/3 sm:w-1/4 md:w-auto flex justify-center p-2 md:p-0'>
                <img src={NETFLIX} alt="Netflix logo" className='w-[60px] sm:w-[70px] md:w-[80px]' />
            </div>
        </div>
    )
}

export default CompanyLogoImage
